export const selectCoachRequests = (state) => state.coach.requests;
export const selectDecidingId = (state) => state.coach.decidingId;
export const selectDecisionError = (state) => state.coach.decisionError;
export const selectCoaches = (state) => state.coach.coaches;
